import React from 'react';

import classes from './NavigationItems.css';
import NavigationItem from './NavigationItem/NavigationItem';
import {  Button, Col } from 'react-bootstrap';

const navigationItems = ( props ) => (
    <ul className={classes.NavigationItems}>
        {/* <NavigationItem link="/" exact>Home</NavigationItem>
        <NavigationItem link="/About" exact>Dedicated</NavigationItem> */}
        {!props.isAuthenticated
            ? <Button variant="outline-dark" size="lg">Authenticate</Button>
            : <NavigationItem link="/logout">Logout</NavigationItem>}
    </ul>
);

export default navigationItems;


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItems.js